import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress"; // Import for loading indicator

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // New loading state
  const navigate = useNavigate();

  const handleLogin = async () => {
    setLoading(true); // Set loading to true
    try {
      const response = await axios.post(
        "http://localhost:5001/api/v1/admin/login",
        {
          asl_username: username,
          asl_pass: password,
        }
      );
      localStorage.setItem("token", response.data.token);

      const { asl_kullanici_ad, asl_kullanici_soyad } = response.data;

      navigate("/admin-panel", {
        state: {
          asl_kullanici_ad,
          asl_kullanici_soyad,
        },
      });
    } catch (err) {
      setError("Kullanıcı adı veya şifre yanlış");
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <Box
          width="100%"
          maxWidth="400px"
          p={3}
          boxShadow={3}
          borderRadius={2}
          bgcolor="background.paper"
        >
       <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', color: '#333' }}>
            Asil Kullanıcı Girişi
          </Typography>
          <TextField
            label="İsim"
            variant="outlined"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            label="Şifre"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {error && <Typography color="error">{error}</Typography>}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleLogin}
            disabled={loading} // Disable button when loading
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              borderRadius: '10px', // Rounded corners
              "&:hover": {
                backgroundColor: "#115293",
                transform: 'scale(1.01)', // Subtle hover effect
              },
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "GİRİŞ YAP"} {/* Show loading indicator */}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default AdminLogin;
